import fetcher from './Fetcher'

api = process.env.VUE_APP_API

export default
    review:
        get: (movie_id) ->
            fetcher.get api + "review?movie_id=#{movie_id}"
        post: (movie_id, data) ->
            fetcher.post api + "review", {data..., 'movie_id':movie_id}
        patch: (review_id, data) ->
            fetcher.patch api + "review/#{review_id}", data
        delete: (review_id, data) ->
            fetcher.delete api + "review/#{review_id}"

    review_episode:
        set: (episode_id) ->
            fetcher.post api + "review/episode/#{episode_id}"
        unset: (episode_id) ->
            fetcher.delete api + "review/episode/#{episode_id}"
        set_bulk: (episode_ids) ->
            fetcher.post api + "review/episode_bulk_set", {ids: episode_ids}
        unset_bulk: (episode_ids) ->
            fetcher.post api + "review/episode_bulk_delete", {ids: episode_ids}

    movie:
        get: (year_from, year_to, votes_from, votes_to, meta_info) ->
            fetcher.get api + "movie?year_from=#{year_from}&year_to=#{year_to}&votes_from=#{votes_from}&votes_to=#{votes_to}&meta_info=#{meta_info}"
        changeHidden: (movie_id, hidden) ->
            fetcher.patch api + "movie/#{movie_id}", {'hidden': hidden}

    collection:
        add: (movie_id) ->
            fetcher.post api + "add", {'movie_id': movie_id}

    settings:
        get: ->
            fetcher.get api + "settings"
        post: (data, name) ->
            fetcher.post api + "settings", {'settings_json': data, 'name': name}
        patch_name: (settings_id, name) ->
            fetcher.patch api + "settings/#{settings_id}", {'name': name}
        patch_data: (settings_id, data) ->
            fetcher.patch api + "settings/#{settings_id}", {'settings_json': data}
        delete: (settings_id) ->
            fetcher.delete api + "settings/#{settings_id}"
